// extracted by mini-css-extract-plugin
module.exports = {"row":"Analytics_row__sekc9","tabs":"Analytics_tabs__3_oTr","title":"Analytics_title__3vNPs","wrap":"Analytics_wrap__7whzh"};